export default __webpack_public_path__ + "static/media/header-large.b8b6308c.jpg";